import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import CareersHeroSection from './CareersHeroSection';
import CareersValuesSection from './CareersValuesSection';
import CareersLifeSection from './CareersLifeSection';
import CareersPerksSection from './CareersPerksSection';
import CareersPositionsSection from './CareersPositionsSection';
import CareersNewsletterSection from './CareersNewsletterSection';

const CareersPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <CareersHeroSection />

      {/* Our Values Section */}
      <CareersValuesSection />

      {/* Life at Company Section */}
      <CareersLifeSection />

      {/* Perks Section */}
      <CareersPerksSection />

      {/* Open Positions Section */}
      <CareersPositionsSection />

      {/* Newsletter Section */}
      <CareersNewsletterSection />

      <Footer />
    </div>
  );
};

export default CareersPage;
